import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-4" },
    [
      _c(
        VRow,
        { staticClass: "mt-6", attrs: { "no-gutters": "" } },
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [_c("app-title", { attrs: { texto: "FILTROS" } })],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12", md: "6" } },
            [
              _c("select-multiple-unidades", {
                attrs: {
                  "mapeamento-id": _vm.diagnostico
                    ? _vm.diagnostico.mapeamento.id
                    : null,
                },
                model: {
                  value: _vm.filtro.unidades,
                  callback: function ($$v) {
                    _vm.$set(_vm.filtro, "unidades", $$v)
                  },
                  expression: "filtro.unidades",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12", md: "6" } },
            [
              _c(VAutocomplete, {
                staticClass: "mx-2",
                attrs: {
                  items: _vm.motivos,
                  "item-text": "descricao",
                  label: "Motivo",
                  "prepend-icon": "library_books",
                  placeholder: "Digite para pesquisar...",
                  "no-results-text": "Nenhum resultado encontrado.",
                  required: "",
                  "return-object": "",
                  multiple: "",
                  "small-chips": "",
                  "deletable-chips": "",
                },
                on: {
                  change: function ($event) {
                    _vm.pesquisa.motivo = ""
                  },
                },
                model: {
                  value: _vm.filtro.motivos,
                  callback: function ($$v) {
                    _vm.$set(_vm.filtro, "motivos", $$v)
                  },
                  expression: "filtro.motivos",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "mt-6", attrs: { "no-gutters": "" } },
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [_c("app-title", { attrs: { texto: _vm.tituloTabelaDispensas } })],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _vm.diagnostico
                ? _c(VDataTable, {
                    attrs: {
                      items: _vm.dispensasView,
                      headers: _vm.headers,
                      search: _vm.opcoes.pesquisa,
                      "sort-by": _vm.opcoes.ordenarPor,
                      "sort-desc": _vm.opcoes.decrescente,
                      "custom-filter": _vm.customFilter,
                      "item-key": "id",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "top",
                          fn: function () {
                            return [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("app-sort", {
                                        model: {
                                          value: _vm.opcoes,
                                          callback: function ($$v) {
                                            _vm.opcoes = $$v
                                          },
                                          expression: "opcoes",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(VCol, {
                                    attrs: { cols: "0", md: "4" },
                                  }),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("app-search", {
                                        model: {
                                          value: _vm.opcoes,
                                          callback: function ($$v) {
                                            _vm.opcoes = $$v
                                          },
                                          expression: "opcoes",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: `item.n`,
                          fn: function ({ index }) {
                            return [_vm._v(_vm._s(++index))]
                          },
                        },
                        {
                          key: `item.servidor`,
                          fn: function ({ item }) {
                            return [
                              _vm._v(" " + _vm._s(item.usuario.nome) + " "),
                              item.fonte
                                ? _c(
                                    VChip,
                                    {
                                      staticClass: "ml-2",
                                      attrs: {
                                        color: "success",
                                        outlined: "",
                                        "x-small": "",
                                      },
                                    },
                                    [_vm._v(" Importado ")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: `item.acoes`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _vm.diagnostico.status ===
                                              "FUTURO" && !item.fonte
                                              ? _c(
                                                  VBtn,
                                                  _vm._g(
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        color: "secondary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.editar(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("edit"),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Clique no botão para editar a dispensa"
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _vm.diagnostico.status === "FUTURO"
                                              ? _c(
                                                  VBtn,
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        color: "error",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.confirmarExclusao(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("delete"),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Clique no botão para excluir a dispensa"
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialog-remove", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.dialogRemove.visibilidade,
            expression: "dialogRemove.visibilidade",
          },
        ],
        attrs: {
          "confirm-action": _vm.excluir,
          "dialog-visible": _vm.dialogRemove.visibilidade,
          "toogle-visible": _vm.toogleDialogRemove,
          descricao: "Você realmente deseja excluir essa dispensa?",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }